import { Stack } from '@mui/material';
import { LinkReturnToMain, Loader } from 'Components';
import { AppliesContext } from 'Context/AppliesContext';
import { useIsDesktop } from 'Hooks';
import { useContext, useState } from 'react';
import { Title } from './Title';
import { AdvancedSearchTitle } from 'Components/AdvancedSearchTitle';
import { AdvancedSearchPaper } from 'Components/AdvancedSearchPaper';
import { NoApplies } from './NoApplies';
import { SearchForm } from './SearchForm';
import { ApplicationDetailsList } from './ApplicationDetailsList';
import { SelectedFiltersDisplay } from './SelectedFiltersDisplay';

export const AppliesLobbyMain = () => {
  const isDesktop = useIsDesktop();
  const { isLoading, applications, filtersData, isFilterByYear, showFilters } =
    useContext(AppliesContext);
  const [advancedSearchOpen, setAdvancedSearchOpen] = useState<boolean>(false);

  const showFilterLabels = () =>
    (filtersData.title ||
      filtersData.number ||
      filtersData.status ||
      !filtersData.includePhoneRequests ||
      !filtersData.includeWebRequests ||
      (isFilterByYear
        ? filtersData.year
        : filtersData.from || filtersData.to)) &&
    showFilters;

  return (
    <Stack gap={isDesktop ? '54px' : '32px'}>
      <LinkReturnToMain />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {applications.length === 0 ? (
            <NoApplies />
          ) : (
            <Stack
              gap={isDesktop ? '28px' : '32px'}
              maxWidth={isDesktop ? '960px' : 'initial'}
            >
              <Title />
              {!advancedSearchOpen && (
                <AdvancedSearchTitle
                  advancedSearchOpen={advancedSearchOpen}
                  openAdvancedSearch={() => setAdvancedSearchOpen(true)}
                />
              )}
              {advancedSearchOpen && (
                <AdvancedSearchPaper
                  scroll={!isDesktop}
                  closeAdvancedSearch={setAdvancedSearchOpen}
                  height={isDesktop ? 'auto' : '100%'}
                >
                  <SearchForm
                    closeAdvancedSearch={() => setAdvancedSearchOpen(false)}
                  />
                </AdvancedSearchPaper>
              )}
              {showFilterLabels() && <SelectedFiltersDisplay />}
              <ApplicationDetailsList />
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};
